import createAxios from 'config/axios'

export const getNotifications = () => createAxios.get('optinoutmanager/v1/notifications')

export const putNotifications = ({ payload }) =>
  createAxios.put('optinoutmanager/v1/notifications', { notifications: payload })
